import tinycolor from 'tinycolor2';
import { Company } from '@/util/types/serverTypes';

/**
 * Get button styles based on company branding colors
 * @param company - Company object containing color and colorSecondary
 * @param useSecondary - Whether to use secondary color for action buttons (default: true)
 * @returns Object with backgroundColor and color styles, or empty object for default styling
 */
export function getCompanyButtonStyles(
  company?: Company | { color?: string; colorSecondary?: string } | null,
  useSecondary: boolean = true
): { backgroundColor?: string; color?: string } {
  // Return early if no company provided
  if (!company) {
    return {};
  }

  // Use secondary color for action buttons if available and requested
  if (useSecondary && company.colorSecondary) {
    const textColor = tinycolor(company.colorSecondary).isLight()
      ? '#000000'
      : '#ffffff';
    return {
      backgroundColor: company.colorSecondary,
      color: textColor,
    };
  }

  // Fall back to primary color
  if (company.color) {
    const textColor = tinycolor(company.color).isLight()
      ? '#000000'
      : '#ffffff';
    return {
      backgroundColor: company.color,
      color: textColor,
    };
  }

  // Return empty object for default HeroUI styles
  return {};
}

/**
 * Get className for buttons when no company colors are available
 * @param company - Company object
 * @returns className string for fallback styling
 */
export function getCompanyButtonFallbackClass(
  company?: Company | { color?: string; colorSecondary?: string } | null
): string {
  return !company || (!company.color && !company.colorSecondary)
    ? 'bg-black text-white'
    : '';
}
